import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { ViewReportContent } from "@/components/portal/apps/reporting/custom/ViewReportContent";
import { searchAsStrings } from "@/components/portal/apps/reporting/custom/columnFilterParams";

/**
 * Search params on this route are an open map of filter-key → value pairs that
 * the report page seeds its filter state from on first load. Drill-through
 * from a dashboard tile uses this to carry both bound dashboard parameters
 * (`{tileFilterKey}=value`) and the clicked-datum filter (`cf.{column}.eq=value`)
 * into the standalone view. We accept any string-keyed string-valued record
 * rather than enumerating filter keys statically because each report has its
 * own filter set and column-filter names are runtime-derived. Numeric and
 * boolean values come back as text (`searchAsStrings`): the router parses
 * `cf.Year.eq=2026` as a number.
 */
type ReportSearch = Record<string, string>;

export const Route = createFileRoute("/portal/apps/reporting/custom/$slug")({
  component: ViewCustomReportPage,
  validateSearch: (search: Record<string, unknown>): ReportSearch => searchAsStrings(search),
});

function ViewCustomReportPage() {
  const { slug } = useParams({ from: "/portal/apps/reporting/custom/$slug" });
  const search = useSearch({ from: "/portal/apps/reporting/custom/$slug" });
  return <ViewReportContent slug={slug} initialFilterValues={search} />;
}
